import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getListProductPricing(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-product-pricing/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "GET", url, requestOptions);

    yield put({ type: "GET_LIST_PRODUCT_PRICING_RESPONSE", value: response });
  } catch (error) {
    yield put({ type: "GET_LIST_PRODUCT_PRICING_RESPONSE", value: error });
  }
}

function* deleteProductPricing(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-product-pricing/" + actions.productUuid + "/" + actions.pricingUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);


    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "DELETE_PRODUCT_PRICING_RESPONSE", value: { ...response, responseStatus } });
  } catch (error) {
    yield put({ type: "DELETE_PRODUCT_PRICING_RESPONSE", value: { ...error, responseStatus: "error" } });
  }
}


function* updateProductPricing(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-pricing/" + actions.productUuid + "/" + actions.pricingUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);


    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "UPDATE_PRODUCT_PRICING_RESPONSE", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "UPDATE_PRODUCT_PRICING_RESPONSE", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* createProductPricing(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-pricing/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "CREATE_PRODUCT_PRICING_RESPONSE", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "CREATE_PRODUCT_PRICING_RESPONSE", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

export function* getListSagaProductPricing() {
  yield takeEvery("GET_LIST_PRODUCT_PRICING", getListProductPricing);
}

export function* createSagaProductPricing() {
  yield takeEvery("CREATE_PRODUCT_PRICING", createProductPricing);
}

export function* updateSagaProductPricing() {
  yield takeEvery("UPDATE_PRODUCT_PRICING", updateProductPricing);
}

export function* deleteSagaProductPricing() {
  yield takeEvery("DELETE_PRODUCT_PRICING", deleteProductPricing);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
